import {css} from "@panda/css";

import {Text} from "@pg-design/text-module";
import {KM_HM_TEST_IDS} from "@pg-mono/test-ids";

import {RoomSelector} from "@/components/room_selector/RoomSelector";

import {HOME_MATCH_PREFERENCES_WIZARD_CONTENT} from "../../constants/preferences/home_match_preferences_wizard_content";

const {ROOMS_LABEL} = HOME_MATCH_PREFERENCES_WIZARD_CONTENT;

export const HomeMatchPreferencesWizardRoomsStep = () => {
    return (
        <div className={roomsStyle}>
            <Text color="var(--colors-gray-900)" preserveFontSize variant="body_copy_2">
                {ROOMS_LABEL}
            </Text>
            <RoomSelector dataTestId={KM_HM_TEST_IDS.PREFERENCES_WIZARD_ROOMS} name="rooms" />
        </div>
    );
};

const roomsStyle = css({
    "--select-active-color": "var(--colors-secondary)",
    "--select-active-text-color": "var(--colors-white)",
    display: "flex",
    flexDirection: "column",
    gap: 2
});
import {css} from "@panda/css";

import {Text} from "@pg-design/text-module";
import {KM_HM_TEST_IDS} from "@pg-mono/test-ids";

import {RoomSelector} from "@/components/room_selector/RoomSelector";

import {HOME_MATCH_PREFERENCES_WIZARD_CONTENT} from "../../constants/preferences/home_match_preferences_wizard_content";

const {ROOMS_LABEL} = HOME_MATCH_PREFERENCES_WIZARD_CONTENT;

export const HomeMatchPreferencesWizardRoomsStep = () => {
    return (
        <div className={roomsStyle}>
            <Text color="var(--colors-gray-900)" preserveFontSize variant="body_copy_2">
                {ROOMS_LABEL}
            </Text>
            <RoomSelector dataTestId={KM_HM_TEST_IDS.PREFERENCES_WIZARD_ROOMS} name="rooms" />
        </div>
    );
};

const roomsStyle = css({
    "--select-active-color": "var(--colors-secondary)",
    "--select-active-text-color": "var(--colors-white)",
    display: "flex",
    flexDirection: "column",
    gap: 2
});
